let selectPeople_global = "0"; //owner_id     默认空
let options_global = {}; //所有人员数据的对象
let peopleName_global = "直属团队"; //owner_id   对应的名字  默认所有下属
let parent_global = {}; //返回按钮数组数据
let selectOu_global = "";
const selectPeople_territoryId = "";

let page_evection = {
  current: 1,
  size: 5,
  total: 0,
};
let page_weekplan = {
  current: 1,
  size: 5,
  total: 0,
};
let page_cultivate = {
  current: 1,
  size: 5,
  total: 0,
};
let page_firmjob = {
  current: 1,
  size: 5,
  total: 0,
};
let page_vacation = {
  current: 1,
  size: 5,
  total: 0,
};
let page_medical = {
  current: 1,
  size: 5,
  total: 0,
};
let page_business = {
  current: 1,
  size: 5,
  total: 0,
};
let page_conference = {
  current: 1,
  size: 5,
  total: 0,
};
let page_onlinemeetting = {
  current: 1,
  size: 5,
  total: 0,
};
let page_tutoring = {
  current: 1,
  size: 5,
  total: 0,
};
let page_jurisdictionin = {
  current: 1,
  size: 5,
  total: 0,
};
let page_cz_sale = {
  current: 1,
  size: 10,
  total: 0,
};
let page_speaker = {
  current: 1,
  size: 5,
  total: 0,
};

let page_compliance = {
  current: 1,
  size: 5,
  total: 0,
};

let page_bulk_send = {
  current: 1,
  size: 5,
  total: 0,
};

let page_bulk_send_hcp = {
  current: 1,
  size: 5,
  total: 0,
};


let task_index = 0;
let date = "";
//选择辖区全局id
let territory_id = "";
let territory_name = "";
// 首页
let territory_home_id = "";
let territory_home_name = "";

export default {
  date,
  selectPeople_global,
  options_global,
  peopleName_global,
  parent_global,
  page_evection,
  page_weekplan,
  page_cultivate,
  page_firmjob,
  page_vacation,
  page_medical,
  page_business,
  page_conference,
  page_onlinemeetting,
  page_tutoring,
  page_jurisdictionin,
  task_index,
  territory_id,
  territory_name,
  territory_home_id,
  territory_home_name,
  selectOu_global,
  selectPeople_territoryId,
  page_cz_sale,
  page_speaker,
  page_compliance,
  page_bulk_send,
  page_bulk_send_hcp
};



// WEBPACK FOOTER //
// ./src/APIService/global_variable.js